export default __webpack_public_path__ + "static/media/telegram.a68ed9ac.png";